import React, { useEffect, useRef } from 'react';
import { animateOwl, animateEyes } from '../utils/owlAnimation';
import '../styles/components/AnimatedOwl.scss';

const AnimatedOwl = () => {
    const owlRef = useRef(null);
    const leftEyeRef = useRef(null);
    const rightEyeRef = useRef(null);

    useEffect(() => {
        if (owlRef.current) {
            animateOwl(owlRef.current);
        }

        if (owlRef.current && leftEyeRef.current && rightEyeRef.current) {
            animateEyes(owlRef.current, leftEyeRef.current, rightEyeRef.current);
        }
    }, []);

    return (
        <div className="animated-owl-container" ref={owlRef}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 400 400"
                className="animated-owl"
            >
                {/* Main Owl Body Shape */}
                <path
                    d="M200,50 C260,50 310,100 310,190 C310,280 260,350 200,350 C140,350 90,280 90,190 C90,100 140,50 200,50 Z"
                    fill="#2A2D35"
                    stroke="#C8A35F"
                    strokeWidth="3"
                />

                {/* Triangle Shape */}
                <path
                    d="M120,130 L200,300 L280,130 Z"
                    fill="#171920"
                    stroke="#C8A35F"
                    strokeWidth="2"
                />

                {/* Left Eye Outer Circle */}
                <circle
                    cx="150"
                    cy="150"
                    r="40"
                    fill="#171920"
                    stroke="#C8A35F"
                    strokeWidth="2"
                />

                {/* Right Eye Outer Circle */}
                <circle
                    cx="250"
                    cy="150"
                    r="40"
                    fill="#171920"
                    stroke="#C8A35F"
                    strokeWidth="2"
                />

                {/* Left Eye Inner Circle */}
                <circle
                    cx="150"
                    cy="150"
                    r="25"
                    fill="#C8A35F"
                    ref={leftEyeRef}
                    className="owl-eye"
                />

                {/* Right Eye Inner Circle */}
                <circle
                    cx="250"
                    cy="150"
                    r="25"
                    fill="#C8A35F"
                    ref={rightEyeRef}
                    className="owl-eye"
                />

                {/* Left Eye Pupil */}
                <circle
                    cx="150"
                    cy="150"
                    r="10"
                    fill="#171920"
                    className="owl-pupil"
                />

                {/* Right Eye Pupil */}
                <circle
                    cx="250"
                    cy="150"
                    r="10"
                    fill="#171920"
                    className="owl-pupil"
                />

                {/* Beak */}
                <path
                    d="M180,180 L200,210 L220,180 Z"
                    fill="#C8A35F"
                    stroke="#171920"
                    strokeWidth="1"
                />

                {/* Left Wing */}
                <path
                    d="M90,190 C60,220 50,260 70,300 C100,270 110,230 90,190 Z"
                    fill="#2A2D35"
                    stroke="#C8A35F"
                    strokeWidth="2"
                    className="owl-wing"
                />

                {/* Right Wing */}
                <path
                    d="M310,190 C340,220 350,260 330,300 C300,270 290,230 310,190 Z"
                    fill="#2A2D35"
                    stroke="#C8A35F"
                    strokeWidth="2"
                    className="owl-wing"
                />

                {/* Feather Details */}
                <path
                    d="M150,230 C160,240 180,245 200,245 C220,245 240,240 250,230"
                    fill="none"
                    stroke="#C8A35F"
                    strokeWidth="2"
                    strokeLinecap="round"
                />

                <path
                    d="M140,260 C160,270 180,275 200,275 C220,275 240,270 260,260"
                    fill="none"
                    stroke="#C8A35F"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        </div>
    );
};

export default AnimatedOwl;